import { Badge, Button, DataList, Separator, Text, useDisclosure } from "@chakra-ui/react";
import { Parts, UI } from "components";
import { Mask } from "config";
import { Styles } from "config";
import useWithdrawals from "hooks/useWithrawals";

export default function Current(){

    const withdrawals = useWithdrawals()
    const withdraw = withdrawals.data?.data?.filter(item => [2,3].includes(item.status))?.[0]
    const cancel = useDisclosure()
    const status = Styles.withdrawStatus(withdraw?.status)

    return(
    <>
    <UI.Box>
        <Text children="Último pedido de saque:" color="GrayText" mb={4} />
        <Badge colorPalette={status.colorPalette}><UI.Icon name="waiting" /> {withdraw?.status_label}</Badge>
        <Text children={<UI.Number.Amount value={withdraw?.total} />} fontSize="2xl" fontWeight="bold" />

        <Separator my={2} />

        <DataList.Root orientation="horizontal">
            <DataList.Item>
                <DataList.ItemLabel children="Data do pedido:" />
                <DataList.ItemValue children={Mask.dateTime(withdraw?.created_at)} />
            </DataList.Item>
        </DataList.Root>

        <Button size="xs" mt={4} variant="ghost" colorPalette="red" onClick={cancel.onOpen} disabled={withdraw?.status !== 2}><UI.Icon name="cancel" /> Cancelar pedido de saque</Button>
    </UI.Box>

    <Parts.Dialog.Withdraws.Cancel data={withdraw} {...cancel} />
    </>
    )
}